// React and  Capacitor
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Keyboard } from '@capacitor/keyboard';

// Components
import Navigation from '../Navigation/Navigation';

// Style>
import styles from './Layout.module.scss';

/**
 * Component used to display page layout witht the bottom navigation
 */
const Layout = ({ children }) => {
  const isNavigationDisplayed = useSelector((state) => state.app.navigationDisplayed);

  /** This useEffect handle the keyboard opening on mobile devices by scrolling
   * the active element into view to prevent the keyboard from covering the input.
   * For more information on the scrollIntoView method, see the links below
   * https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
   * https://capacitorjs.com/docs/v5/apis/keyboard
   * */
  useEffect(() => {
    const keyboardListener = Keyboard.addListener('keyboardDidShow', () => {
      if (document.activeElement) {
        document.activeElement.scrollIntoView({
          block: 'center',
        });
      }
    });

    // Cleanup
    return () => {
      keyboardListener.remove();
    };
  }, []);
  return (
    <div className={styles.layout}>
      {isNavigationDisplayed ? <div className={styles.layout__content}>{children}</div> : children}

      {isNavigationDisplayed && <Navigation />}
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.any.isRequired,
};
export default Layout;
